import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export default function SEO({ 
  title, 
  description, 
  keywords, 
  ogImage = 'https://amibites.com/logo.png',
  canonical,
  type = 'website'
}) {
  const location = useLocation()
  const baseUrl = 'https://amibites.com'
  const fullUrl = canonical || `${baseUrl}${location.pathname}`

  useEffect(() => {
    if (title) {
      document.title = title
    }

    const metaTags = [
      { name: 'description', content: description },
      { name: 'keywords', content: keywords },
      { property: 'og:title', content: title },
      { property: 'og:description', content: description },
      { property: 'og:url', content: fullUrl },
      { property: 'og:image', content: ogImage },
      { property: 'og:type', content: type },
      { name: 'twitter:title', content: title },
      { name: 'twitter:description', content: description },
      { name: 'twitter:image', content: ogImage },
    ]

    metaTags.forEach(({ name, property, content }) => {
      if (content) {
        const attribute = name ? 'name' : 'property'
        const value = name || property
        let element = document.querySelector(`meta[${attribute}="${value}"]`)
        
        if (!element) {
          element = document.createElement('meta')
          element.setAttribute(attribute, value)
          document.head.appendChild(element)
        }
        element.setAttribute('content', content)
      }
    })

    let canonicalLink = document.querySelector('link[rel="canonical"]')
    if (!canonicalLink) {
      canonicalLink = document.createElement('link')
      canonicalLink.setAttribute('rel', 'canonical')
      document.head.appendChild(canonicalLink)
    }
    canonicalLink.setAttribute('href', fullUrl)

  }, [title, description, keywords, ogImage, fullUrl, type])

  return null
}
